//配置全局访问接口地址
export default {
	cos() {
		return 'https://carpool-1301582899.cos.ap-guangzhou.myqcloud.com';
	},
};
